<template>
  <v-tabs :value="value" background-color="transparent" color="primary" grow @change="emitir">
    <v-tab>Dia</v-tab>
    <v-tab>Ultimos 10 dias</v-tab>
    <v-tab>Periodo</v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "HorarioTabs",
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    emitir(value) {
      this.$emit("input", value);
    },
  },
};
</script>
